import { Injectable } from '@angular/core';
import { AppStorage } from '../../enums/app-storage';

@Injectable({
  providedIn: 'root',
})
export class PreviousRouteService {
  private previousParams: Record<string, string> | null = null;

  constructor() {
    this.previousParams = this.getInitialPreviousParams();
  }

  getInitialPreviousParams(): Record<string, string> | null {
    const localStoragePreviousParams = localStorage.getItem(
      AppStorage.previousParams
    );
    return localStoragePreviousParams
      ? JSON.parse(localStoragePreviousParams)
      : null;
  }

  setPreviousParams(params: Record<string, string>) {
    this.previousParams = params;
    localStorage.setItem(AppStorage.previousParams, JSON.stringify(params));
  }

  getPreviousParams(): Record<string, string> | null {
    return this.previousParams;
  }

  clearPreviousParams() {
    this.previousParams = null;
    localStorage.removeItem(AppStorage.previousParams);
  }
}
